<template>
    <section :class="option.class">
        <div class="cropper"  v-if="option.img">
            <app-vue-cropper
                :ref="(option.ref ? option.ref : 'cropper')"
                :img="option.img"
                :outputSize="option.size"
                :outputType="option.outputType"
                :info="true"
                :full="option.full"
                :canMove="option.canMove"
                :canMoveBox="option.canMoveBox"
                :fixedBox="option.fixedBox"
                :original="option.original"
                :canScale="option.canScale"
                :autoCrop="option.autoCrop"
                :autoCropWidth="option.autoCropWidth"
                :autoCropHeight="option.autoCropHeight"
                :fixed="option.fixed"
                :fixedNumber="option.fixedNumber"
                @realTime="realTime">
            </app-vue-cropper>
        </div>
        <div class="options-cropper" :style="(!option.img ? 'width:100%' : false)">
            <div class="buttons">
                <label class="el-button el-button--primary" for="upload">Cargar imagen</label>
                <input  type="file"
                        id="upload"
                        style="position:absolute; clip:rect(0 0 0 0);"
                        accept="image/png, image/jpeg, image/gif, image/jpg"
                        @change="uploadImg($event, 1)">
                <button @click="startCrop" v-if="!crap" type="button" class="el-button el-button--primary">Editar</button>
                <button @click="stopCropCustom" v-else  type="button" class="el-button el-button--primary">Listo</button>
                <button @click="clearCrop" type="button" class="el-button el-button--primary">Limpiar</button>
            </div>

            <div class="show-preview"
                :style="{'width': previews.w + 'px', 'height': previews.h + 'px',  'overflow': 'hidden', 'margin': '5px'}">
                <div :style="previews.div">
                    <img :src="previews.url" :style="previews.img" >
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import VueCropper from "vue-cropper"

    export default {
        name: "cropper",
        props: ['options'],
        components: {
            'app-vue-cropper': VueCropper
        },
        created () {
            
            this.options ? this.option = this.options : this.option = this.optionsDefault;
            
        },
        data () {
            return {
                show: false,
                crap: false,
                previews: {},
                downImg: '#',
                option: {},
                rotate: null,
                optionsDefault: {
					img: null,
					size: 1,
					full: true,
					outputType: "jpg",
					canMove: true,
					fixedBox: false,
					original: false,
					canMoveBox: false,
					class: 'cropper-medium'
				},
            }
        },
        methods: {
            getFile(value){
                return new File([value], 'imagen.jpg', {type: 'image/jpeg', lastModified: Date.now()});
            },
            startCrop () {
                this.crap = true
                this.$refs.cropper.startCrop()
                this.$parent.$emit('imagenCargada', this.getFile(this.previews.url))
            },
            stopCropCustom () {
                this.crap = false
                this.$refs.cropper.stopCrop()
                this.$refs.cropper.getCropBlob((data) => {
                    this.$root.$emit('imagenCargada', this.getFile(data))
                })
            },
            clearCrop () {
                this.crap = false
                this.$refs.cropper.clearCrop()
            },
            realTime (data) {
                this.previews = data
            },
            rotateLeft () {
                this.rotate = this.rotate <= -3 ? 0 : this.rotate - 1
            },
            rotateRight () {
                this.rotate = this.rotate >= 3 ? 0 : this.rotate + 1
            },
            uploadImg (e, num) {
                var file = e.target.files[0]
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isLt2M) {
                    this.$message.error({
                        type: 'ERROR',
                        message: 'La imagen excede los 2MB y no puede ser cargada!'
                    });
                    return false;
                }

                if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
                   // alert('Tipo de archivo aceptado: .gif,jpeg,jpg,png,bmp')
                    return false
                }
                var reader = new FileReader()
                reader.onload = (e) => {
                    let data
                    if (typeof e.target.result === 'object') {
                            data = window.URL.createObjectURL(new Blob([e.target.result]))
                        } else {
                            data = e.target.result
                        }
                        this.option.img = data
                    }
                    reader.readAsArrayBuffer(file)
                    this.$root.$emit('imagenCargada', this.getFile(file))
                }
            }
        }
</script>

<style lang="scss" scoped>
	.div-cropper {
		height: 500px;
	}
    
    .cropper  {
        height: 500px;
        padding: 15px 0;
        margin-bottom: 25px;
    }
    .options-cropper{
        display: flex;
        align-items: start;
        justify-content: space-between;
        flex-direction: row-reverse;

        height: auto;
        padding: 15px 0;
        margin-bottom: 25px;
    }
    .show-preview {
        display: block;
    }
    .preview {
        position: relative;
        height: auto;
        overflow: hidden;
    }
    .all{
        position: relative;
    }
	.cropper-medium {
		display: flex;
		align-items: stretch;
		justify-content: space-between;
		> .cropper {
			width: 50%;
		}
		> .options-cropper {
			width: 50%;
			display: flex;
			align-items: flex-start;
			justify-content: flex-start;
			flex-flow: row wrap;
			.buttons{
				width: 100%;
				order: 1;
				text-align: center;
			}
			.show-preview{
				order: 2;
				margin: 0 auto !important;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/commons/cropper2.vue